// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment} from 'react';
import {Link} from 'react-router-dom';
import cn from 'classnames';
import {Faq, i_faq_props} from '../common/faq';
import styles from './faq.module.less';
import {useLocation} from 'react-router';
import {use_data_provider} from '../../../../hola/pub/lib/use_data_provider';
const test_guide_url = 'https://support.oculusproxies.com/hc/en-us/articles'
    +'/23101526359835-Integrate-your-proxies-into-any-browser';

const get_hp_faq_client = theme=>[
    {
        quest: 'Why do I need proxies?',
        ans: <p className={cn(theme.p14, theme.med)}>
          Proxies are a necessity for any bot or tool when scraping
          or trying to purchase something from a website. Proxies
          allow you to run more tasks, decrease the odds of being
          banned, and have a faster connection to most websites.
        </p>,
    },
    {
        quest: 'What is an ISP Proxy?',
        ans: <p className={cn(theme.p14, theme.med)}>
          This is the highest quality Residential proxies leased from
          Internet Service Providers (ISP) in various countries that
          you can purchase. This plan works great on eCommerce
          websites with bot protection such as Shoppy, Walmart,
          Target, Best Buy, Amazon, and more.
        </p>,
    },
    {
        quest: 'What is a ISP Premium Proxy?',
        ans: <p className={cn(theme.p14, theme.med)}>
          This is the highest quality Residential proxies leased from
          US Internet Service Providers (ISP). This plan works great
          on Google related and key social media websites allowing
          for unblocked access from US Residential IP addresses.
        </p>,
    },
    {
        quest: 'What is an Datacenter Proxy?',
        ans: <p className={cn(theme.p14, theme.med)}>
          Oculus Data Center Proxies is a shared DC plan which comes
          at a very affordable cost. This product's main purpose is
          for web scraping.
        </p>,
    },
    {
        quest: 'Is there a Free Plan?',
        ans: <Fragment>
          <p className={cn(theme.p14, theme.med)}>
            Yes, after signup you can get a free package of 5
            Datacenter IP's with 100MB bandwidth, this plan is
            valid for 7 days.
          </p>
          <p className={cn(theme.p14, theme.med)}>
            You can activate the free plan, from the datacenter
            product page or <Link to="/pricing">pricing page</Link>
          </p>
        </Fragment>,
    },
    {
      quest: 'Is KYC required for residential proxy access?',
      ans: <p className={cn(theme.p14, theme.med)}>In general, no, you do not
        need KYC to use Oculus proxies. However, there are some extended
        services that are not open to the general public, and if a customer
        wishes to use those, they will be required to complete a KYC process.
        </p>
    },
    {
        quest: 'How do you price your proxies?',
        ans: <p className={cn(theme.p14, theme.med)}>
          Oculus pricing model is very straightforward. We have only
          prepaid, flat rate plans with no hidden costs.
          <br/>
          Shared proxies, whether datacenter (DC) or ISP are priced
          by the volume of data you'll send via the proxies, measured
          in gigabytes (GB). You can select the plan according to the
          amount of GB you expect to use. The price is usually the
          same per GB in the various plans with some discount on the
          larger packages. Packages are valid for 3 months from the
          time of purchase
          <br/>
          Dedicated proxies Datacenter or ISP Premium are allocated
          exclusively for your use, priced by the number of proxies (
          $/proxy)
          <br/>
          Dedicated proxy pairs will be allocated to you for 1 month,
          and you can select package according to the number of
          proxies you'll need. Price is typically the the same per
          proxy with some discount on the larger packages.
        </p>,
    },
    {
        quest: 'What proxy protocols are supported?',
        ans: <p className={cn(theme.p14, theme.med)}>
          HTTP, HTTPS, and SOCKS5 proxy connection protocols.
        </p>,
    },
    {
        quest: 'Can I test my proxies?',
        ans: <p className={cn(theme.p14, theme.med)}>
          Sure! Check out our free proxy testing tool guide{' '}
          <a href={test_guide_url}>here</a>
        </p>,
    },
    {
        quest: 'Where can I get proxies for Events?',
        ans: <p className={cn(theme.p14, theme.med)}>
          We provide dedicated Events Proxies optimized for this use
          case, These proxies can be purchased and managed on our
          legacy website, https://oculusproxies.com/legacy
        </p>,
    },
    {
        quest: 'How does auto-renewal work?',
        ans: <p className={cn(theme.p14, theme.med)}>
          When auto renewal is enabled for a plan, once usage will
          reach 90% of the plan or it will be 5 days before the plan
          expiration, we'll automatically generate new plan. The
          remaining GB or time that were not used will be added to
          the new plan so nothing is lost
        </p>,
    },
    {
        quest: 'How to use the residential scraper proxies?',
        ans: <p className={cn(theme.p14, theme.med)}>
          To prevent misuse and to protect our partners who share
          their residential IPs, Oculus uses dedicated SSL
          certificate to monitor the activity done via the proxy and
          prevent abuse. You'll need to{' '}
          <a
            href="https://oculusproxies.com/assets/crts/certificate.crt"
            target="_blank" rel="noopener noreferrer"
          >
            Download SSL certificate
          </a>
          . In some cases it may be possible to use the proxies
          without installing the SSL but will require ignoring SSL
          errors.
        </p>,
    },
    {
        quest: 'Can I purchase dedicated datacenter from different '
            +'countries?',
        ans: <p className={cn(theme.p14, theme.med)}>
          Yes, we provide dedicated DC proxies from many countries,
          for each plan you purchase you can select one country for
          the purchased IP's. If you need additional country, you can
          purchase additional plan.
        </p>,
    },
    {
        quest: 'Which proxy type is best for me?',
        ans: <p className={cn(theme.p14, theme.med)}>
          Oculus offers 4 types of proxies and although all provide
          fast and effective access to the internet from the desired
          locations, each type has its own advantages and the use
          cases it best fits.
          <br/> <br/>
          <b>Datacenter (DC)</b>
          <br/>
          These proxies are provided through our datacenter servers
          around the world and provide the fastest and most cost
          effective option. Datacenter proxies are most suitable for
          accessing websites that are not using advanced blocking
          methods.
          <br/>
          Typical use cases: eCommerce, social media profiles,
          general purpose data scraping from various websites.
          <br/>
          We Offer Datacenter proxies in two different plans:
          <br/>
          Shared Datacenter is a pool of proxies that your requests
          are channelled through them together with other users'
          requests. This is the most cost effective option offered at
          very affordable prices in different Bandwidth packages
          Dedicated Datacenter proxies are allocated exclusively to
          you and you will be the only one using them for the entire
          plan duration. This allows you to fully control which
          websites are accessed from these proxies, keeping them
          "clean" from any unwanted interferences.
          <br/>
          <br/>
          <b>ISP - Internet Service Providers</b>
          <br/>
          Pool of IP's leased from leading ISP providers around the
          world that are classified as residential IP's, allowing you
          to access websites as an individual living in the target
          location while still enjoying high speed connectivity and
          data collection.
          <br/>
          ISP proxies are best suitable for accessing hard to reach
          websites while maintaining a real user behaviour. ISP
          allows access to websites that may be blocked when using
          Datacenter proxies.
          <br/>
          Typical use cases: data and price scraping, performing,
          geolocation based actions and more
          <br/>
          <br/>
          <b>ISP Premium</b>
          <br/>
          These proxies are from a US based pool of ISP IP's and are
          designed to provide smooth access to Google search engine
          and various social media websites that may be blocked for
          regular ISP proxies.
          <br/>
          We provide ISP Premium Proxies as unshared (dedicated) so
          you can select which websites they will access and prevent
          unwanted influence that may be caused by other users using
          these IP's in parallel.
          <br/>
          Typical use cases: Google search, google related websites,
          social media accounts, eCommerce, Events or business
          related websites you'd like to access from a US bases
          location. These IP addresses remain static and the same
          throughout the duration of the plan.
          <br/>
          <br/>
          <b>Residential Scraper Proxies</b>
          <br/>
          These are real residential IP's provided through our
          partners in a most secure and compliance way. These proxies
          are provided in "read only" mode that allow you to easily
          scrape data from any website, from any location globally
          but without performing actions like filling form or posting
          on social media. This mode is designed to protect those
          individuals who agree to share their IPs with us.
          <br/>
          Typical use cases: unblocked, accurate data scraping from
          any website you need, ensuring the data you collect is
          identical to what will be presented to any real user.
        </p>,
    },
    {
      quest: 'Can I use Oculus proxies for SMTP checks?',
      ans: <p className={cn(theme.p14, theme.med)}>
        No, SMTP and email-related activities, including email verification
        via SMTP checks, are not approved use cases for Oculus proxies.
        Our residential proxies are configured to restrict common SMTP ports,
        including port 25, to maintain security and prevent misuse.
      </p>
    }
];

type t_hp_faq_props = Partial<i_faq_props>;
export const HP_faq = (props: t_hp_faq_props)=>{
  const {title, get_questions} = props;
  const {pathname} = useLocation();
  const get_data_id =()=>`schema-faqs-${pathname}`;
  const {data} = use_data_provider(get_data_id);
  const get_hp_faq =theme=>
    data?.result?.data?.map(item=>({
      quest: item.quest,
      ans:
        <div
          className={cn(theme.p14, theme.med)}
          dangerouslySetInnerHTML={{__html: item.ans}}
        />
    }));
  return (
    <div className={cn(styles.faq)}>
      <div className={styles.container}>
        <Faq
          get_questions={data?.result
            ? get_hp_faq : get_questions || get_hp_faq_client}
          title={title}
          questions_shown={6}
        />
      </div>
    </div>
  );
};
